<!-- eslint-disable -->
<script setup>
import { useI18n } from 'vue-i18n';
import { useRegisterStore } from '../../stores/register';

const { t } = useI18n();
const registerStore = useRegisterStore();
</script>

<template>
	<div class="register-form-field">
		<label>{{$t('account.register.gender')}}</label>
		<select name="" @change="registerStore.validateGender" v-model="registerStore.register_input_fields.gender" class="form-input form-control" id="address-country">
			<option :value="null" disabled>{{$t('account.register.gender')}}</option>
			<option value="male">{{ $t('general.male') }}</option>
			<option value="female">{{ $t('general.female') }}</option>
		</select>
		<div class="register-form-list" v-if="registerStore.register_errors.gender.error">
			<div class="password-meter">
				<div class="password-meter-bar">
					<div class="password-meter-bar-inn"></div>
				</div>
			</div>
			<p>
				<img src="@/assets/svgs/cross.svg" alt=""/>
				&nbsp;
				<span v-if="registerStore.register_errors.gender.error == 'error_select_gender'">
					{{ $t('account.register.error_select_gender') }}
				</span>
				<span v-else-if="registerStore.register_errors.hasOwnProperty('gender')">
					{{ registerStore.register_errors.gender.error }}
				</span>
			</p>
		</div>
	</div>
</template>

<style scoped>
.register-form-main .register-outer-form .register-inner-form .password-meter .password-meter-bar {
	background-color:var(--red);
	margin-bottom:5px;
}
.register-form-main .register-form-list {
	margin-top:unset;
	padding-top:5px;
}
html[dir="rtl"] .register-form-main .register-outer-form .register-inner-form select {
	background-position: 5%;
}
html[dir="rtl"] .register-form-main .register-outer-form .register-inner-form .form-input {
	padding: 10px 15px 10px 15px;
}
</style>